import { useRef, useCallback } from "react";

export default function ResizeHandle({ colKey, onResize }) {
  const handleRef = useRef(null);

  const onMouseDown = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();

    const th = e.target.closest("th");
    const table = th?.closest("table");
    if (!table) return;

    // Ensure table uses fixed layout
    table.style.tableLayout = "fixed";

    // Get all col elements and set explicit widths on ALL of them
    const cols = Array.from(table.querySelector("colgroup")?.children || []);
    const ths = Array.from(th.parentElement.children);
    cols.forEach((col, i) => {
      if (ths[i]) col.style.width = ths[i].offsetWidth + "px";
    });

    // Set table width = sum of all column widths
    const totalW = ths.reduce((sum, h) => sum + h.offsetWidth, 0);
    table.style.width = totalW + "px";

    const thIndex = ths.indexOf(th);
    const col = cols[thIndex];
    if (!col) return;

    const startX = e.clientX;
    const startColW = th.offsetWidth;
    const startTableW = totalW;

    if (handleRef.current) handleRef.current.style.backgroundColor = "#2383E2";

    const overlay = document.createElement("div");
    overlay.style.cssText = "position:fixed;inset:0;z-index:9999;cursor:col-resize;";
    document.body.appendChild(overlay);

    const onMouseMove = (ev) => {
      const diff = ev.clientX - startX;
      const newColW = Math.max(50, startColW + diff);
      // Only change THIS column's width + total table width
      col.style.width = newColW + "px";
      table.style.width = (startTableW + (newColW - startColW)) + "px";
    };

    const onMouseUp = (ev) => {
      if (handleRef.current) handleRef.current.style.backgroundColor = "";
      overlay.remove();
      document.removeEventListener("mousemove", onMouseMove);
      document.removeEventListener("mouseup", onMouseUp);
      const diff = ev.clientX - startX;
      onResize(colKey, Math.max(50, startColW + diff));
    };

    document.addEventListener("mousemove", onMouseMove);
    document.addEventListener("mouseup", onMouseUp);
  }, [colKey, onResize]);

  return (
    <div
      ref={handleRef}
      onMouseDown={onMouseDown}
      className="absolute right-0 top-[4px] bottom-[4px] w-[3px] cursor-col-resize rounded-full bg-[#D0D0CC] hover:bg-[#2383E2] transition-colors z-10"
      data-testid={`resize-${colKey}`}
    />
  );
}
